query instructorsFilter($filterId: ID, $scenarioId: ID!, $pagination: PaginationInput) {
  filter(scenarioId: $scenarioId) {
    instructors(filterId: $filterId, pagination: $pagination) {
      items {
        id
        code
        name
        priority
        usable
        contract
        assignment {
          totalAssignedBlocks
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        page
        size
        total
      }
    }
  }
}
